/* bvm-scrivici.js — «SCRIVICI» (24/10/2026, sessione C): la pillola e il pannello del modulo richieste (snippets/bvm-scrivici.liquid).
   Lavora solo sugli attributi data-bvm-scrivici-*. Fa:
   · la pillola apre il pannello (<dialog>, showModal: fuoco dentro, Esc chiude da sé); la × e il clic sul velo lo chiudono; mentre è
     aperto la pagina sotto non scorre (classe nostra su <html>, come il pannello Eventi);
   · dopo un invio riuscito (evento «bvm-richiesta:inviata» del modulo) compare il pulsante «Chiudi»; alla riapertura il modulo torna
     vuoto (evento «bvm-richiesta:azzera», assets/bvm-richiesta.js);
   · nelle pagine che il modulo lo hanno già la pillola non apre niente: porta al modulo della pagina e mette il fuoco sul primo campo;
   · anche l'indirizzo apre: #scrivici;
   · mentre il banner dei cookie di Shopify (#shopify-pc__banner) è aperto e occupa il suo posto, la pillola si toglie: niente
     sovrapposizioni. */
(function () {
  'use strict';
  var root = document.querySelector('[data-bvm-scrivici]'); if (!root || root.__bvmScrivici) return; root.__bvmScrivici = true;
  var pillola = root.querySelector('[data-bvm-scrivici-apri], [data-bvm-scrivici-vai]');
  var dlg = root.querySelector('[data-bvm-scrivici-pannello]');
  var html = document.documentElement;

  // ── pagine col modulo già nella pagina: la pillola porta lì ──
  function vaiAlModulo() {
    var m = Array.prototype.filter.call(document.querySelectorAll('[data-bvm-richiesta]'), function (x) { return !x.closest('[data-bvm-scrivici-pannello]'); })[0];
    if (!m) return;
    m.style.scrollMarginTop = '120px';
    m.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    var primo = m.querySelector('input[name="nome"]');
    if (primo) setTimeout(function () { primo.focus({ preventScroll: true }); }, 500);
  }

  // ── il pannello ──
  var inviato = false;
  var fatto = dlg && dlg.querySelector('[data-bvm-scrivici-fatto]');
  var modulo = dlg && dlg.querySelector('[data-bvm-richiesta]');
  function apri() {
    if (!dlg || typeof dlg.showModal !== 'function' || dlg.open) return;
    if (inviato && modulo) { modulo.dispatchEvent(new CustomEvent('bvm-richiesta:azzera')); inviato = false; if (fatto) fatto.hidden = true; }
    dlg.showModal(); html.classList.add('bvm-scrivici-bloccato');
    if (pillola) pillola.setAttribute('aria-expanded', 'true');
  }
  function chiudi() { if (dlg && dlg.open) dlg.close(); }
  if (dlg) {
    // Lo sblocco della pagina segue l'attributo «open» del <dialog> (lo tolgono close(), Esc e il modulo stesso): l'osservatore lo
    // vede subito; l'evento «close» arriva più tardi e in una scheda in secondo piano può non arrivare affatto (verificato 24/10/2026).
    var sblocca = function () { if (dlg.open) return; html.classList.remove('bvm-scrivici-bloccato'); if (pillola) pillola.setAttribute('aria-expanded', 'false'); };
    if (window.MutationObserver) new MutationObserver(sblocca).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    dlg.addEventListener('close', function () {
      sblocca();
      if (pillola) pillola.focus({ preventScroll: true });
      if (location.hash === '#scrivici') history.replaceState(null, '', location.pathname + location.search);
    });
    dlg.addEventListener('click', function (ev) { if (ev.target === dlg) chiudi(); });   // clic sul velo: il bersaglio è il <dialog>
    Array.prototype.forEach.call(dlg.querySelectorAll('[data-bvm-scrivici-chiudi]'), function (b) { b.addEventListener('click', chiudi); });
    dlg.addEventListener('bvm-richiesta:inviata', function () { inviato = true; if (fatto) fatto.hidden = false; });
  }
  if (pillola) pillola.addEventListener('click', function () { if (pillola.hasAttribute('data-bvm-scrivici-vai')) vaiAlModulo(); else apri(); });
  function daIndirizzo() { if (location.hash !== '#scrivici') return; if (dlg) apri(); else vaiAlModulo(); }
  daIndirizzo(); window.addEventListener('hashchange', daIndirizzo);

  // ── il banner dei cookie: finché è aperto E occupa il posto della pillola, la pillola si toglie (su desktop il banner sta al
  //    centro e la pillola resta; sul telefono il banner prende tutta la larghezza in basso e la pillola sparisce) ──
  function rettangoloBanner() {
    var b = document.getElementById('shopify-pc__banner'); if (!b) return null;
    var cs = getComputedStyle(b), r = b.getBoundingClientRect();
    return cs.display !== 'none' && cs.visibility !== 'hidden' && Number(cs.opacity) > 0 && r.width > 0 && r.height > 0 ? r : null;
  }
  function guardaBanner() {
    if (!pillola) return;
    var b = rettangoloBanner(); if (!b) { pillola.hidden = false; return; }
    pillola.hidden = false; var p = pillola.getBoundingClientRect(), m = 8;   // misura nello stesso istante: nessun lampeggio
    pillola.hidden = p.left < b.right + m && p.right > b.left - m && p.top < b.bottom + m && p.bottom > b.top - m;
  }
  guardaBanner(); setInterval(guardaBanner, 1000);
})();
